import React, { useEffect } from 'react';
import './App.css';
import { Routes, Route, Link, } from "react-router-dom";

//pages
import Login from './Login';
// import Dashboard from './Dashboard';
// import ApplyForm from './ApplyForm';
// import Statistic from './Statistic';
// import TicketInfo from './TicketInfo';
// import CreateItemForm from './CreateItemForm';
import ProtectedRoute from './ProtectedRoute';
// import NotFound from './NotFound';
// import UserProfile from './UserProfile';
// import User from './User';

import TestPage from './TestPage';

import './style/global.css'

const Dashboard = React.lazy(() => import("./Dashboard"));
const ApplyForm = React.lazy(() => import("./ApplyForm"));
const Statistic = React.lazy(() => import("././Statistic"));
const TicketInfo = React.lazy(() => import("./TicketInfo"));
const CreateItemForm = React.lazy(() => import("./CreateItemForm"));
const NotFound = React.lazy(() => import("./NotFound"));
const UserProfile = React.lazy(() => import("./UserProfile"));
const User = React.lazy(() => import("./User"));




function App() {
  useEffect(() => {
    window.addEventListener('beforeunload', () => localStorage.clear());

    return () => {
      window.removeEventListener('beforeunload', () => localStorage.clear());
    }
  }, [])

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Login />} />
        <Route element={<ProtectedRoute />}>

          <Route path="/UserProfile" element={
            <React.Suspense fallback={<>...</>}>
              <UserProfile />
            </React.Suspense>} />

          <Route path="/Dashboard"
            element={<React.Suspense fallback={<>...</>}>
              <Dashboard />
            </React.Suspense>}
          />

          <Route path="/ApplyForm"
            element={
              <React.Suspense fallback={<>...</>}>
                <ApplyForm />
              </React.Suspense>}
          />

          <Route path="/Statistic" element={
            <React.Suspense fallback={<>...</>}>
              <Statistic />
            </React.Suspense>} />

          <Route path="/CreateItemForm" element={
            <React.Suspense fallback={<>...</>}>
              <CreateItemForm />
            </React.Suspense>} />

          <Route path="/TicketInfo" element={<React.Suspense fallback={<>...</>}><TicketInfo /></React.Suspense>} >
            <Route path=":ticketId" element={<React.Suspense fallback={<>...</>}><TicketInfo /></React.Suspense>} />
          </Route>

          <Route path="/User">
            <Route path=":userName" element={
              <React.Suspense fallback={<>...</>}>
                <User />
              </React.Suspense>} />
          </Route>
        </Route>
        <Route path="*" element={<React.Suspense fallback={<>...</>}><NotFound /></React.Suspense>} />
        <Route path="Test" element={<TestPage />} />

      </Routes>
    </div>


  );
}

export default App;
